import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Tab, Tabs } from '../../components/Tabs/Tabs';
import { adminActions } from '../../redux/actions/adminActions';
import CreateTab from './CreateTab';
import DetailTab from './DetailTab';
import MainTab from './MainTab';

const AdminPage = () => {
  const dispatch = useDispatch();
  const { activeTabKey, tabs } = useSelector(state => state.admin);

  return (
    <div>
      <Tabs
        activeKey={activeTabKey}
        onClick={key => dispatch(adminActions.changeTab(key))}
      >
        <Tab title="Admin">
          <MainTab />
        </Tab>
        <Tab title="Buat">
          <CreateTab />
        </Tab>
        {tabs.map((row, key) =>
          <Tab
            key={row.key}
            title={row.title}
            isLoading={row.loading}
            onClose={() => dispatch(adminActions.closeTab(row.key))}
            onClick={() => dispatch(adminActions.changeTab(row.key))}
            active={activeTabKey === row.key}
          >
            <DetailTab index={key} />
          </Tab>
        )}
      </Tabs>
    </div>
  )
}

export default AdminPage
